import '@atlassian/jira-vendor/src/vendor-parcel.tsx';
import '@atlassian/jira-vendor/src/commons-parcel.tsx';

import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getSpaRoutes } from '@atlassian/jira-routes/src/getSpaRoutes.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getCodegenSpaRoutes } from '@atlassian/jira-routes/src/getCodegenSpaRoutes.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { startJiraSpa as oldStartJiraSpa } from './start-jira-spa.tsx';
import { startJiraSpa as altStartJiraSpa } from './start-jira-spa-alt.tsx';
import { shadowRouting } from './shadow-routing.tsx';

setMark('JIRA_SPA_ENTRY_LOADED');

// It is easier to make the check against window than it is to make typescript happy here.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!__SERVER__ && typeof window !== 'undefined' && window.__SPA_BOOTSTRAP_ALT) {
	altStartJiraSpa(() =>
		fg('rollout-codegen-spa-route-map') ? getCodegenSpaRoutes() : getSpaRoutes(),
	);
} else {
	oldStartJiraSpa(() =>
		fg('rollout-codegen-spa-route-map') ? getCodegenSpaRoutes() : getSpaRoutes(),
	);
}

shadowRouting();
